module.exports = __webpack_public_path__ + "images/bannerDE-4112189941f821a991bcdcea04869f50.png";